// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] + "." + {"506":"b752d90b","536":"b71ff525","889":"e71a1003"}[chunkId] + ".js";
};